<template>
  <div class="voucher-consumer-gift-card-amount">
    <div class="secondary-section">
      <consumer-gift-card-download-pdf-modal ref="downloadPdfModal" :voucher-id="voucher.id" :activation-code-id="voucher.activation_code.activation_code_id" @success="refreshGiftCardVouchers"> </consumer-gift-card-download-pdf-modal>

      <h-btn class="button-style" :loading="downloadPdfModalOpening" @click="openDownloadPdfModal" :disabled="voucherIsNotPendingActivation" text small inverted>
        <v-icon left>mdi-wallet-giftcard</v-icon>{{ $t('components.account_voucher_consumer_gift_card_amount.consumer_gift_card_download_pdf_modal_action_title') }}
      </h-btn>

      <consumer-gift-card-send-by-email-modal ref="sendByEmailModal" :voucher-id="voucher.id" :activation-code-id="voucher.activation_code.activation_code_id" @success="refreshGiftCardVouchers"> </consumer-gift-card-send-by-email-modal>

      <h-btn class="button-style" :loading="sendByEmailModalOpening" @click="openSendByEmailModal" :disabled="voucherIsNotPendingActivation" text small inverted>
        <v-icon left>mdi-email-outline</v-icon>{{ $t('components.account_voucher_consumer_gift_card_amount.consumer_gift_card_send_by_email_modal_action_title') }}
      </h-btn>

      <h-btn class="button-style" text small inverted :loading="working" @click="downloadReceipt">
        <v-icon size="20" left>mdi-open-in-new</v-icon>{{ $t('components.account_voucher_consumer_gift_card_amount.consumer_gift_card_payment_success_download_receipt') }}
      </h-btn>

      <merchants-modal :offer_id="voucher.offer_id" :modal-title-text="$t('components.account_voucher_consumer_gift_card.merchants_modal_title')">
        <template #activator="{ on, attrs }">
          <h-btn class="button-style" text small inverted v-bind="attrs" v-on="on" style="justify-content: unset"> <v-icon size="20" left>mdi-store</v-icon>{{ $t('components.account_voucher_consumer_gift_card.merchants_link') }} </h-btn>
        </template>
      </merchants-modal>
    </div>
  </div>
</template>

<script>
import safeExecute from '@/composables/safe-execute';
import ConsumerGiftCardSendByEmailModal from '@/components/consumer-gift-card/components/ConsumerGiftCardSendByEmailModal.vue';
import ConsumerGiftCardDownloadPdfModal from '@/components/consumer-gift-card/components/ConsumerGiftCardDownloadPdfModal.vue';
import MerchantsModal from '@/components/modals/MerchantsModal';

import { mapGetters } from 'vuex';

export default {
  name: 'voucher-consumer-gift-card-amount-and-links',
  components: { MerchantsModal, ConsumerGiftCardSendByEmailModal, ConsumerGiftCardDownloadPdfModal },
  setup(props, { root }) {
    const { executeOverlay, working } = safeExecute(root.$store);
    return {
      executeOverlay,
      working,
    };
  },
  data() {
    return {
      sendByEmailModalOpening: false,
      downloadPdfModalOpening: false,
    };
  },
  props: {
    voucher: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('ui', ['currentLocale']),
    calculatedBalance() {
      return this.voucher.bonus_amount + this.voucher.payment_amount;
    },
    voucherIsNotPendingActivation() {
      return this.voucher.status !== 'pending_activation';
    },
  },
  methods: {
    async openSendByEmailModal() {
      this.sendByEmailModalOpening = true;
      try {
        await this.$refs.sendByEmailModal.openModal();
      } finally {
        this.sendByEmailModalOpening = false;
      }
    },
    async openDownloadPdfModal() {
      this.downloadPdfModalOpening = true;
      try {
        await this.$refs.downloadPdfModal.openModal();
      } finally {
        this.downloadPdfModalOpening = false;
      }
    },

    refreshGiftCardVouchers() {
      this.$emit('refreshGiftCardVouchers');
    },
    async downloadReceipt() {
      await this.executeOverlay(
        {
          action: 'consumerGiftCard/downloadReceipt',
        },
        {
          consumer_gift_card_order_id: this.voucher.consumer.consumer_gift_card_order_id,
          language: this.currentLocale,
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.status-section {
  padding: var(--gap-xsmall) calc(var(--gap-small) - 3px) var(--gap-small);
}

.secondary-section {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
}

.button-style {
  font-size: var(--font-size-text-4);
  margin-left: -10px;
}
</style>
